import { Box, Card, Grid, Typography } from '@mui/material';
import React from 'react';

import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faCloudWord } from '@fortawesome/sharp-regular-svg-icons';
import { useTheme } from '@mui/system';

export type NomsDeDomaine = {
    domaine: string;
};

export type NomsDeDomaineWidgetCallbackArgs = (nomsDeDomaine: NomsDeDomaine, index: number) => void;

export type NomsDeDomaineWidgetType = {
    nomsDeDomaine: NomsDeDomaine;
    actions?: Array<{
        name: string;
        icon?: React.ReactNode | React.FunctionComponent;
        tooltip?: string;
        text?: string;
        onClick: NomsDeDomaineWidgetCallbackArgs;
    }>;
    index?: number;
};

// exemple de style sur DisplayFile

export const NomsDeDomaineWidget: React.FunctionComponent<NomsDeDomaineWidgetType> = function ({
    nomsDeDomaine,
    actions,
    index = -1,
}: NomsDeDomaineWidgetType) {
    const theme = useTheme();
    return (
        <Card sx={{ padding: '10px', cursor: 'pointer', margin: '15px 0' }}>
            <Grid
                container
                sx={{
                    marginLeft: '0px',
                }}
            >
                <Grid
                    item
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        paddingLeft: '0px',
                    }}
                >
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap="10px"
                        sx={{
                            margin: '0 12px 0',
                        }}
                    >
                        <Box
                            data-testid="test-id-status-color-box"
                            sx={{
                                margin: '0px',
                                padding: '10px',
                                borderRadius: '10px',
                                fontSize: '25px',
                                maxHeight: '65px',
                                backgroundColor: theme.palette.icon?.info?.backgroundColor,
                            }}
                        >
                            <FaOptionIcon
                                data-testid="test-id-mimetype-icone"
                                icon={faCloudWord}
                                color={theme.palette.primary.main}
                                sx={{ fontSize: '15px' }}
                            />
                        </Box>
                        <Box sx={{ padding: '10px 10px', minWidth: '150px' }}>
                            <Typography
                                variant="h4"
                                sx={{ fontWeight: 'bold' }}
                            >
                                {nomsDeDomaine.domaine}
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap="10px"
                        sx={{
                            margin: '0 0 0 auto',
                        }}
                    >
                        {actions
                            ? actions.map((action, key) => (
                                  <Box
                                      title={action.tooltip}
                                      data-testid={`test-id-${key}-handleClick-button`}
                                      onClick={() => action.onClick(nomsDeDomaine, index)}
                                      role="button"
                                      key={action.name}
                                  >
                                      {action.icon || action.text}{' '}
                                  </Box>
                              ))
                            : null}
                    </Box>
                </Grid>
            </Grid>
        </Card>
    );
};
